import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import TruncateString from 'react-truncate-string'
import { BASE } from '../api/api'
import { List } from 'react-content-loader'
import Axios from 'axios'
import cachios from 'cachios'
import pr from '../assets/pr.jpg'
import home from '../assets/Home/home.png'
import togglearrow from '../assets/Home/togglearrow.png'
import crumbarrow from '../assets/Home/right.png'
import load from '../assets/loading.gif'
import Loader from 'react-loader'
import Header from '../header/newheader'
import FooterNew from '../footer/newfooter';
import pageleft from '../assets/Home/pageleft.png'
import pagenoleft from '../assets/Home/pagenoleft.png'
import pagenoright from '../assets/Home/pagenoright.png'
import pageright from '../assets/Home/pageright.png'
import SideBar from '../sidebar/sidebar'
import TopBar from '../topbar/topbar';
import "./faculty.css"


class NewFaculty extends Component {
    constructor(props) {
        super(props);
        console.log(props, "123")
        this.state = {
            people: '',
            bioimage: '',
            imagearray: '',
            limit: 15,
            offset: props.match.params.page ? parseInt(props.match.params.page, 10) : 0,
            next: false,
            prev: false,
            filter: '',
            filterchk: '',
            page: props.match.params.page ? parseInt(props.match.params.page, 10) : 0,
            type: 'faculty'
        }
    }

    componentWillReceiveProps(nextProps) {
        if (new URLSearchParams(nextProps.location.search).get("faculty") !== null) {
            this.setState({
                offset: 0,
                page: 0,
                filterchk: new URLSearchParams(this.props.location.search).get("faculty")
            }, () => this.apicall(0, `filter[field_faculty_type]=${new URLSearchParams(this.props.location.search).get("faculty")}`))
        }
        else if (new URLSearchParams(nextProps.location.search).get("programe") !== null) {
            this.setState({
                offset: 0,
                page: 0,
                filterchk: new URLSearchParams(this.props.location.search).get("programe")
            }, () => this.apicall(0, `filter[field_programe.name]=${new URLSearchParams(this.props.location.search).get("programe")}`))
        }
        else
            this.apicall(0, '')
    }

    //filter list
    filterlist() {
        cachios.get(BASE + 'api/faculty_filter_list', {
            ttl: 500 /* seconds */,
        })
            .then((data) => {
                console.log(data, 'found')

                this.setState({
                    filterlist: data.data.data,
                })
            })
            .catch((err) => {
                console.log('not found')
            })
    }
    //setting filter and apicall
    setfilter(type, value, programe_name) {
        let filterchk = this.state.filterchk
        console.log(filterchk, type, 'filterchk', "programname:", programe_name, "value", value)
        if (programe_name) {
            localStorage.setItem('related_faculty_head', programe_name)
        }
        else {
            localStorage.setItem('related_faculty_head', value)
        }
        if (type == "programe") {
            this.setState({
                people: "",
                filterchk: programe_name
            })
            this.props.history.push(`/research/faculty?${type}=${programe_name}`)
            this.apicall(0, `filter[field_programe.name]=${new URLSearchParams(this.props.location.search).get("programe")}`)
            this.setState({
                offset: 0
            })
        }
        else {
            this.setState({
                people: "",
                filterchk: value
            })
            this.props.history.push(`/research/faculty?${type}=${value}`)
            this.apicall(0, `filter[field_faculty_type]=${new URLSearchParams(this.props.location.search).get("faculty")}`)
            this.setState({
                offset: 0
            })
        }
    }
    settype(type) {
        this.setState({
            type: type
        })
        this.setState({
            page: 0,
            offset: 0
        })
        this.props.history.push('/research/' + type)

    }
    //Next/previous click function
    handlePageClick = data => {
        console.log(data, this.state.filter, 'offset')

        let filterchk = this.state.filterchk ? this.state.filterchk : 'all'
        let filter = this.state.filter ? this.state.filter : 'all'

        if (data === 'next' && this.state.next === true) {
            this.setState({
                people: '',
            })
            this.setState({
                offset: this.state.offset + 1
            }, () => this.apicall(this.state.offset, ''))
            // history.push('/faculty?page='+this.state.offset)

        }
        else if (data === 'prev' && this.state.prev === true) {
            this.setState({
                people: '',
            })
            this.setState({
                offset: this.state.offset - 1
            }, () => this.apicall(this.state.offset, ''))
            // this.apicall(this.state.offset-1,this.state.filter)
        }
    };

    topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
    filterapi() {
        Axios.get(BASE + 'api/faculty_search', {
            ttl: 500 /* seconds */,
        })
            .then((data) => {
                console.log(data, 'xxx')
                this.setState({
                    people: data.data.data
                })
            })
    }
    signout() {
        localStorage.removeItem('token');
        localStorage.removeItem('expirytime');
        localStorage.removeItem('expiryref');
        // window.location.href = '/'

    }


    refreshexp() {
        let s = new Date();
        s.setSeconds(s.getSeconds() + 1800);
        localStorage.setItem('expiryref', s)
    }


    checkexpiry() {
        if (localStorage.getItem('expiryref')) {
            let expref = Date.parse(localStorage.getItem('expiryref'))
            let s = new Date();
            if (s > expref) {
                this.signout()
            }
            else {
                this.refreshexp()
            }

        }
        else {
            this.signout()
        }
    }




    componentWillMount() {
        if (localStorage.getItem('token'))
            this.checkexpiry()
        this.filterlist()
        if (new URLSearchParams(this.props.location.search).get("faculty") !== null) {
            this.setState({
                offset: 0,
                page: 0,
                filterchk: new URLSearchParams(this.props.location.search).get("faculty")
            }, () => this.apicall(0, `filter[field_faculty_type]=${new URLSearchParams(this.props.location.search).get("faculty")}`))
        }
        else if (new URLSearchParams(this.props.location.search).get("programe") !== null) {
            this.setState({
                offset: 0,
                page: 0,
                filterchk: new URLSearchParams(this.props.location.search).get("programe")
            }, () => this.apicall(0, `filter[field_programe.name]=${new URLSearchParams(this.props.location.search).get("programe")}`))
        }
        else
            this.apicall(this.state.offset, this.state.filter)
        localStorage.removeItem('faculty');
        localStorage.removeItem('facultypub');

    }
    pagestore(id) {

        localStorage.setItem('pagenum', JSON.stringify(id))

    }
    apicall(id, filter) {
        console.log("api is calling with ", id, filter)
        localStorage.removeItem('pagenum')
        if (id <= 0) {
            this.setState({
                prev: false,
            })
        }
        else {
            this.setState({
                prev: true
            })
        }
        //to check Next page
        console.log('filter present' + filter)
        console.log('filterchck ' + this.state.filterchk)
        if (filter == '' || filter == 'all') {
            Axios.get(`${BASE}jsonapi/node/faculty?include=field_image&sort=field_landing_page_sort_order`)
                .then(faculty => {
                    this.setState({
                        newfaculty: faculty.data.data,
                        facultyincluded: faculty.data.included
                    })
                })
                .catch(err => {

                })
            cachios.get(BASE + `api/rest/faculty_search?format=json&page=${this.state.offset}&sort=field_sort_order`, {
                ttl: 500 /* seconds */,
            })
                .then((data) => {
                    if (localStorage.getItem('token'))
                        this.checkexpiry()
                    this.setState({
                        newfaculty: data.data.data,
                        facultyincluded: data.data.included
                    })
                })
                .catch((err) => {
                    // this.setState({
                    //     people: data.data.rows,
                    //     count: data.data.pager.total_pages
                    // })
                    // if (data.data.pager) {
                    //     this.setState({
                    //         next: data.data.pager.current_page < (data.data.pager.total_pages - 1) ? true : false
                    //     })
                    // }
                    this.topFunction();
                    console.log('not found')
                })
        }
        else {
            cachios.get(`${BASE}jsonapi/node/faculty?include=field_image&sort=field_sort_order&${filter}`, {
                ttl: 500 /* seconds */,
            })
                .then((data) => {
                    if (localStorage.getItem('token'))
                        this.checkexpiry()


                    console.log(data, 'xxx')
                    this.setState({
                        newfaculty: data.data.data,
                        facultyincluded: data.data.included
                    })
                    if (data.data.pager) {
                        this.setState({
                            next: data.data.pager.current_page < (data.data.pager.total_pages - 1) ? true : false
                        })

                    }
                    localStorage.setItem('related_faculty', JSON.stringify(data.data.data))
                    this.topFunction();
                })
                .catch((err) => {
                    console.log('not found')
                })
        }

        console.log(BASE + 'api/faculty_search?' + filter + '&page=' + (id), "123321", this.state.filterchk)

    }
    render() {

        return (
            <div className=''>
                <Header />
                <div className="title-banner">
                    <h1 className="heading-one bold white-text">CIS Staff</h1>
                </div>
                <div className='container clusterpage'>
                    <div className="page-people" >
                        <div className='top-contents'>
                            <div className="new-crumbs breadcrumbs gray-text"><Link to='/' className='gray-text'><img className='crumb-home' src={home} /></Link><img className='rightarrow' src={crumbarrow} /><Link to='/research/faculty?faculty=Dean' className='gray-text'>Research</Link><img className='rightarrow' src={crumbarrow} /><Link to='/research/faculty' className='gray-text'>CIS Staff</Link></div>
                            {/* <TopBar data={'data1'} /> */}

                        </div>
                        <div className="body-two gray-text text-justify">
                            HBKU is confident that it will achieve its goal of building a leading global research university through the hard-work, dedication, and incredible talent of its faculty and staff. As a growing university, it is dedicated to recruiting the finest faculty and staff from around the world committed to achieving its mission. HBKU's faculty and staff work together to build a truly integrated learning community and a dynamic campus by collaborating with other faculty and staff from partner universities.
                        </div>
                        <div className="main-content">
                            <div className="">
                                <div className='faculty_container'>
                                    <div className='toggle-container'>
                                        {this.state.filterlist ?
                                            this.state.filterlist.data_faculty_type.map((value, ind) => {
                                                return <div>
                                                    <div style={{ cursor: value.field_faculty_type === "Faculty" ? 'pointer' : 'pointer', }} onClick={() => this.setfilter('faculty', value.field_faculty_type)} className={value.field_faculty_type === "Dean" ? 'toggle-head heading-three bold blue-text dean' : "toggle-head heading-three bold blue-text"}>
                                                        {value.field_faculty_type ? value.field_faculty_type === "Research" ? "Researchers" : value.field_faculty_type : 'All Faculty'}
                                                        {new URLSearchParams(this.props.location.search).get("faculty") === value.field_faculty_type ? <img className='toggle-arrow' src={togglearrow} /> : ""}
                                                    </div>
                                                    {value.field_faculty_type === 'Faculty' ? new URLSearchParams(this.props.location.search).get("faculty") === "Faculty" || new URLSearchParams(this.props.location.search).get("programe") ?
                                                        <div className='toggle-bar-one'>
                                                            {this.state.filterlist.data_programme.map((subvalue, ind) => {
                                                                return <button style={{ whiteSpace: "unset", display: subvalue.programe_key ? '' : 'none', fontWeight: new URLSearchParams(this.props.location.search).get("programe") === subvalue.programe_key ? '500' : '' }} onClick={() => this.setfilter('programe', subvalue.programe_key, subvalue.programe_name)} className={new URLSearchParams(this.props.location.search).get("programe") === subvalue.programe_name ? 'main-blue-text body-two' : "gray-text body-two"}>
                                                                    <p className="toggle-row" style={{ maxWidth: "320px" }}>
                                                                        {subvalue.programe_name}
                                                                        <span className="button-arrow">
                                                                            {new URLSearchParams(this.props.location.search).get("programe") === subvalue.programe_name ? <img className='toggle-arrow' src={togglearrow} /> : ""}
                                                                        </span>
                                                                    </p>
                                                                </button>
                                                            })}
                                                        </div> : '' : ""}
                                                </div>

                                            })
                                            : ''}
                                    </div>
                                    <div className='faculty_main'>

                                        <div className="view-wiki">
                                            {!this.state.newfaculty ?
                                                <Loader color="#165e84" loaded={false} className="spinner" /> : ''
                                            }

                                            {/* {this.state.people ?
                                                this.state.people.map((people, index) => {
                                                    return (
                                                        <div className="faculty-details">
                                                            <Link className='' onClick={() => this.pagestore(this.state.offset)} to={{ pathname: '/faculty/' + `${people.title.replace(/ /g, "-").toLowerCase()}` + '?nid=' + `${people.nid}`, state: { link: people, img: people.field_image_url ? BASE + people.field_image_url : pr } }}>
                                                                <div className='image-container'>
                                                                    <img src={people.field_image_url ? BASE + people.field_image_url : pr} alt="" />
                                                                </div>
                                                                <div className='subtitle-one bold text-center'>
                                                                    <TruncateString text={people.title.charAt(0).toUpperCase() + people.title.slice(1)} truncateAt={100} />
                                                                </div>
                                                            </Link>
                                                        </div>)
                                                }) : <List />} */}
                                            {this.state.newfaculty ?
                                                this.state.newfaculty.map((people, index) => {
                                                    let image = people.relationships.field_image.data ? this.state.facultyincluded.filter(x => x.id === people.relationships.field_image.data.id)[0].attributes.uri.url : ""
                                                    return (
                                                        <div className="faculty-details">
                                                            <Link className='' onClick={() => this.pagestore(this.state.offset)} to={{ pathname: '/faculty/' + `${people.attributes.title.replace(/ /g, "-").toLowerCase()}` + '?nid=' + `${people.attributes.drupal_internal__nid}`, state: { link: people, img: people.field_image_url ? BASE + people.field_image_url : pr } }}>
                                                                <div className='image-container'>
                                                                    <img src={image ? BASE + image : pr} alt="" />
                                                                </div>
                                                                <div className='subtitle-one bold text-center'>
                                                                    <TruncateString text={people.attributes.title ? people.attributes.title.charAt(0).toUpperCase() + people.attributes.title.slice(1) : ""} truncateAt={100} />
                                                                </div>
                                                            </Link>
                                                            {/* <Link className='subtitle-one bold text-center' onClick={() => this.pagestore(this.state.offset)} to={{ pathname: '/faculty/' + `${people.title[0].replace(/ /g, "-").toLowerCase()}` + '?nid=' + `${people.nid[0]}`, state: { link: people, img: people.field_image_url ? BASE + people.field_image_url[0] : pr } }}>
                                                            </Link> */}
                                                        </div>)
                                                }) : <List />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* {this.state.people ? <div className='new-pagination'>
                                <button disabled={!this.state.prev} onClick={() => this.handlePageClick('prev')} className='prev'>{!this.state.prev ? <img src={pagenoleft} /> : <img src={pageleft} />}</button>   <div className='pageno'>{this.state.offset ? (this.state.offset) + 1 : 1}</div><span className='pagination-of'> of </span><div className='total'>{this.state.count ? this.state.count : 1}</div> <button disabled={!this.state.next} onClick={() => this.handlePageClick('next')} className='next'>{this.state.next ? <img src={pageright} /> : <img src={pagenoright} />}</button>
                            </div> : ""} */}
                        </div>
                    </div>
                    <div>
                        {/* responsive filter */}
                        <div class="button-responsive">
                            <button onClick={() => this.setState({
                                fpopup: !this.state.fpopup
                            })} class="filter">Filter</button>
                            <i class="filter-icon"></i>
                        </div>
                        {/* MObile FIlter */}
                        <div className='mobile_filter' style={{ display: this.state.fpopup ? '' : 'none' }}>
                            <div className='mobile_filter_head' >
                                <div>Filters</div>
                                <div onClick={() => this.setState({
                                    fpopup: !this.state.fpopup
                                })}>X</div>
                            </div>
                            <div className="filter_block">
                                <div className="filter_container">
                                    <div className='faculty_filter'>
                                        {this.state.filterlist ?
                                            this.state.filterlist.data_faculty_type.map((value, ind) => {
                                                return <div>
                                                    <div style={{ cursor: value.field_faculty_type === "Faculty" ? 'normal' : '', fontWeight: this.state.filterchk === value.field_faculty_type ? '500' : '', backgroundColor: this.state.filterchk === value.field_faculty_type ? '#165E84' : '', color: this.state.filterchk === value.field_faculty_type ? 'white ' : '' }} onClick={() => this.setfilter('faculty_type', value.field_faculty_type)} className='faculty_filter_value'>
                                                        {value.field_faculty_type ? value.field_faculty_type : 'All Faculty'}
                                                    </div>
                                                    {value.field_faculty_type === 'Faculty' ?
                                                        <div className='faculty_subfilter'>
                                                            {this.state.filterlist.data_programme.map((subvalue, ind) => {
                                                                return <div style={{ display: subvalue.programe_key ? '' : 'none', fontWeight: this.state.filterchk === subvalue.programe_key ? '500' : '', backgroundColor: this.state.filterchk === subvalue.programe_key ? '#165E84' : '', color: this.state.filterchk === subvalue.programe_key ? 'white ' : '' }} onClick={() => this.setfilter('programe', subvalue.programe_key, subvalue.programe_name)} className='faculty_subfilter_value'>
                                                                    {subvalue.programe_name}
                                                                </div>
                                                            })}
                                                        </div> : ''}
                                                </div>
                                            })
                                            : ''}
                                    </div>
                                    <div class="button-responsive">
                                        <button onClick={() => this.setState({
                                            fpopup: !this.state.fpopup
                                        })} class="filter">Apply Filter</button>
                                        <i class="filter-icon"></i>
                                    </div>

                                </div>

                            </div>

                        </div>
                    </div>
                </div>
                <div className="filterfooter">
                    <FooterNew />
                </div>
            </div>
        )


    }

}

export default NewFaculty;
